module.exports = __webpack_public_path__ + "static/media/icon_167.e8eefcb2.png";